<template>
  <div class="wrapper">
    <div class="trip-dates-wrapper">
      <div class="field-wrapper">
        <date-selection
          ref="departureDate"
          v-focusout:calendar="departureDateClose"
          :label="$t('searchForm.dateSelection.departure.label')"
          class="departure"
          :is-return="calendar.type === 'return'"
          :placeholder="$t('searchForm.dateSelection.placeholder')"
          :value="calendar.departureInputText"
          :name="'flt_leaving_on'"
          :is-mobile="isMobile"
          :error="calendar.departureErrors.length > 0"
          :class="{'full': tripType === 'oneway', 'active': departureActive && calendar.departureErrors.length === 0 }"
          :calendar-icon="calendarIcon"
          focus-out-force-open="onDepartureDateFocused"
          @focused="onDepartureDateFocused"
          @minDatePicked="onMinDateChanged"
          @maxDatePicked="onMaxDateChanged"
        />
        <date-selection
          v-if="tripType !== 'oneway'"
          ref="returnDate"
          v-focusout:calendar="returnDateClose"
          :label="$t('searchForm.dateSelection.return.label')"
          :is-return="calendar.type === 'return'"
          :name="'flt_returning_on'"
          :placeholder="$t('searchForm.dateSelection.placeholder')"
          :value="calendar.returnInputText"
          :is-mobile="isMobile"
          :class="[{ 'active': returnActive && calendar.returnErrors.length === 0 }]"
          :error="calendar.returnErrors.length > 0"
          :calendar-icon="calendarIcon"
          focus-out-force-open="onFocused"
          @focused="onReturnDateFocused"
          @minDatePicked="onMinDateChanged"
          @maxDatePicked="onMaxDateChanged"
        />
      </div>
    </div>
    <calendar
      v-if="calendar.visible"
      ref="calendar"
      v-focusout="onCalendarClickedOutside"
      :class="{'overlay': calendar.visible}"
      :default-min-date="calendar.departureDate"
      :default-max-date="calendar.returnDate"
      :is-mobile="isMobile"
      :is-return="['return', 'multi'].includes(tripType)"
      :trip-type="calendar.type"
      :direct-flights="directFlights"
      :auto-open-date="calendar.autoOpenDate"
      :direct-flights-round-trip="directFlightsRoundTrip"
      :direct-flights-text="$t('searchForm.originDestin.directFlights')"
      :loading-status="loadingStatus"
      :modal-title="$t('searchForm.paxSelector.modalWindow.headerTextEHorizon')"
      :return-selected="returnActive"
      :show-footer="false"
      @closed="onCalendarClosed"
      @minDatePicked="onCalendarMinDatePicked"
      @maxDatePicked="onCalendarMaxDatePicked"
    />
  </div>
</template>

<script>
  import { mapState, mapGetters } from 'vuex'
  import DateSelection from 'components/Dates/DatesSelectionWhite'
  import Calendar from 'components/Dates/CalendarWhite'
  import CalendarMixin from 'components/eHorizon/SearchFormMixins/Calendar'
  import Focusout from 'utils/directives/FocusOut'

  export default {
    directives: {
      Focusout
    },
    components: {
      DateSelection,
      Calendar
    },
    mixins: [
      CalendarMixin
    ],
    props: {
      calendarIcon: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        departureActive: false,
        returnActive: false
      }
    },
    computed: {
      ...mapState('eHorizonSearchForm', [
        'directFlights',
        'directFlightsRoundTrip',
        'calendar',
        'tripType',
        'loadingStatus'
      ]),
      ...mapGetters('device', [
        'isMobile'
      ])
    },
    methods: {
      onDepartureDateFocused () {
        if (this.isMobile) {
          this.$refs.departureDate.blurInput()
        }
        this.returnActive = false
        this.departureActive = true
        this.$store.commit('eHorizonSearchForm/calendar/openDepartureCalendar')
      },
      onReturnDateFocused () {
        if (this.isMobile) {
          this.$refs.returnDate.blurInput()
        }
        this.departureActive = false
        this.returnActive = true
        this.$store.commit('eHorizonSearchForm/calendar/openReturnCalendar')
      },
      departureDateClose () {
        if (!this.isMobile) {

          if (['return', 'multi'].includes(this.tripType)) {
            this.onCalendarClosed()
          }
          if (this.$refs.returnDate && !this.$refs.returnDate.hasFocus()) {
            this.onCalendarClosed()
          }
          this.departureActive = false
        }
      },
      returnDateClose () {
        if (!this.$refs.departureDate.hasFocus() && !this.isMobile) {
          this.onCalendarClosed()
        }
        this.returnActive = false
      },
    }
  }
</script>


<style lang="scss" scoped rel="stylesheet/scss">
  @import "~assets/styles/common.scss";

  .wrapper {
    position: relative;
  }

  .trip-dates-wrapper {
    max-width: 272px;

    @include bp-mf-desktop {
      max-width: 375px;
    }
  }

  .field-wrapper {
    display: flex;
    position: relative;
    flex-direction: row;
    justify-content: space-between;
    max-width: 272px;
    align-items: center;

    @include bp-mf-desktop {
      max-width: 375px;
    }

    .date-field-group {
      display: flex;
      width: calc(50% - 4px);
      margin-bottom: 16px;

      @include bp-mf-tablet {
        height: 56px;
        margin-bottom: 0;
        width: 100%;
      }

      &.full {
        width: 100%;
      }

      &.error {

        ::v-deep .date-field-wrap {
          border: 1px solid $red-dark !important;
        }
      }

      &.active {
        border: 2px solid $blue-medium;

        ::v-deep .date-field-wrap {
          padding: 4px 23px 2px 8px;
        }

        &:after {
          transform: rotate(270deg);
        }

        &.calendar:after {
          transform: none;
          top: 18px;
          right: 12px;
        }
      }

      .date-field-wrap {
        border: 1px solid $grey-border;
        border-radius: 3px;
        background-color: white;
        box-shadow: inset -1px 0 0 0 rgba(#000000, 0.1);

        input {

          @include bp-mf-desktop {
            height: 40px;
          }
        }
      }
    }
  }
</style>
